import {useEffect, useState} from "react";
import moment from "moment";
import DateRangePickerComponent from "../../../components/common/CustomDateRangePicker";
import {FormControl, InputAdornment, MenuItem, IconButton, Box, Button, CircularProgress, Grid,  Pagination, Paper, Select, styled, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import ReportsTableHeader from "../report-table-header.component";
import VerificationFrequencySkeleton from "../skeleton/verificaiton-frequency-skeleton";
import ExportAlertNotificationDialog from "../../alert/export-alert-notification-dialog.component";
import ReportService from "../../../services/api/reports";
import CachedIcon from "@mui/icons-material/Cached";
import ReactSelect from "react-select";
import {useSnackbar} from "notistack";
import ClearIcon from "@mui/icons-material/Clear";

const SmallSelect = styled(Select)(({ theme, fontColor }) => ({
    minWidth: 120,  // Adjust the width as needed
    height: 33,     // Adjust the height as needed
    fontSize: '0.875rem',  // Adjust the font size as needed
    '.MuiSvgIcon-root': {
        color: fontColor, // Change to your desired color
    },
    color: fontColor,
    backgroundColor: '#fff',
    border: "1px solid #7A78F7",
    "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiSelect-select": {
        fontSize: 12,
        fontStyle: 'italic'
    },
    "& .MuiMenuItem-root": {
        fontSize: 12,
    },
    "& .Mui-selected": {
        fontSize: 12,
        fontStyle: 'italic'
    },
}));

const filterStyles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        textAlign: "left",
        backgroundColor: "#fff",
        minHeight: 32,
        height: 32,
        padding: "0px 8px", 
        width: "fit-content",
        fontSize: 14,
        borderColor: "rgb(122, 120, 247)",
        '&:hover': {
            borderColor: "rgb(122, 120, 247)", 
        },
        zIndex: 1200,
        flexWrap: "wrap",
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 1200,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999, 
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: "2px 6px",
        flexWrap: "wrap"
    }),
    input: (styles) => ({
        ...styles,
        margin: 0,
        padding: 0, 
    }),
    option: (styles) => ({...styles, textAlign: "left", fontSize: 13}),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)",
        },
        alignSelf: "center"
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)", 
        },
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "rgba(51, 51, 207, 0.808)",
        marginTop: "-3px",
        fontSize: 13,
    }),
    placeholder: (styles) => ({ ...styles, color: "#3333CFCE", marginTop: "-3px", fontSize: 12}), 
    noOptionsMessage: (provided) => ({
        ...provided,
        fontStyle: "italic", 
        textAlign: "start", 
        fontSize: "13px", 
    }),
    multiValue: (styles) => ({
        ...styles,
        backgroundColor: "rgba(122, 120, 247, 0.1)", 
        borderRadius: "8px", 
        padding: "2px 4px", 
        margin: "2px", 
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: "rgb(51, 51, 207)",
        fontWeight: "500", 
        fontSize: "11.5px", 
        padding: "0 4px", 
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        '&:hover': {
            backgroundColor: "rgba(122, 120, 247, 0.2)", 
            color: "rgb(51, 51, 207)", 
        },
    }),
}

const VerificationFrequencyFilterComponent = (props) => {

    const {getVerificationFrequency,loadingVerificationFrequency, listVerificationFrequency,
        headers, page, setPage, listProducts, getUserTypes, listUserTypes} = props;
    
    const {enqueueSnackbar} = useSnackbar();

    const [product_name, setProductName] = useState([]);
    const [isLoadingAlertNotification, setIsLoadingAlertNotification] = useState(false)
    const [reportID, setReportID] = useState(null)
    const [open, setOpen] = useState(false)

    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    const [formattedProductList, setFormattedProductList] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);

    const [user_type, setUserType] = useState("");

    useEffect(() => { 
        getUserTypes();
    }, [])
    
    useEffect(() => {
        if (listProducts) {
            const formattedList = listProducts?.map(product => ({
                label: product.product_name,
                value: product.product_code
            }));

            setFormattedProductList(formattedList);
        }
    }, [listProducts])


    useEffect(() => {
        const start_date = startDate;
        const end_date = endDate;
        const product_code = selectedProducts?.map(product => product.value);

        let payload = {
            start_date: start_date,
            end_date: end_date,
            product_code: product_code,
        }
        
        getVerificationFrequency(payload);
    }, [startDate, endDate, product_name, selectedProducts]);


    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleClose = () =>{
        setOpen(false)
    }

    const handleChangeProductName = (event) => {
        setProductName(event.target.value);
    }

    const itemsPerPage = 100;

    // Calculate the total number of pages
    const totalPages = Math.ceil((listVerificationFrequency?.length || 0) / itemsPerPage);

    // Get the current items to display
    const currentItems = (listVerificationFrequency || []).slice((page - 1) * itemsPerPage, page * itemsPerPage);

    // Handler to change page
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleExport = () => {
        const start_date = startDate;
        const end_date = endDate;
        const product_code = selectedProducts?.map(product => product.value);

        let payload = {
            start_date: start_date,
            end_date: end_date,
            product_code: product_code,
        }

        if (listVerificationFrequency?.length > 0) {
            setIsLoadingAlertNotification(true);

            ReportService.exportVerificationFrequency(payload).then((res)=>{
                console.log('get export alert and notification res here', res)
                setIsLoadingAlertNotification(false)
                setReportID(res?.data?.data?.report_id)
                setOpen(true)
            }).catch(()=>{
                setIsLoadingAlertNotification(false)
            })

        } else {
            enqueueSnackbar("No data to export", { 
                variant: "error",
                autoHideDuration: 3000
            });
        }
       
    }

    const handleClearFilters = (e) => {
        setProductName("");
        setSelectedProducts([]);
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
    }

    const handleSelectProductFilter = (selectedOption) => {
        if (!selectedOption) {
            setProductName("");
            setSelectedProducts([]);

        } else {
            setSelectedProducts(selectedOption); 
        }
    }

    const handleChangeUserType = (event) => {
        setUserType(event.target.value);
    }

    const handleClearUserType = (e) => {
        setUserType("");
    }
  

    return (
        <Box>
            <Grid container sx={{ justifyContent: "flex-end", alignItems: "center", mt: 3}}>
                <Grid item xs={2}>
                    <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                        startIcon={<CachedIcon />} onClick={(e) => handleClearFilters(e)}
                    >
                        Clear Filters
                    </Button>
                </Grid>

                <Grid item xs={10} sx={{display: "flex", justifyContent: "flex-end"}}>
                    <FormControl sx={{ width: 250 }}>
                        <SmallSelect
                            value={user_type}
                            onChange={handleChangeUserType}
                            displayEmpty
                            fontColor={'#5d5ed8'}
                            startAdornment={
                                <InputAdornment position="start">
                                    <p style={{fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: "bold"}}>
                                        User Type:
                                    </p>
                                </InputAdornment>
                            }
                            endAdornment={user_type && 
                                (
                                    <InputAdornment position="end">
                                        <IconButton sx={{mr: "12px"}}
                                            size="small"
                                            onClick={(e) => handleClearUserType(e)}
                                        >
                                            <ClearIcon sx={{color: "#3333CFCE", fontSize: 16}} />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }
                            sx={{
                                "& .MuiSelect-select": {
                                    paddingRight: "0px !important",
                                },
                            }}
                        >
                            <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                <em>Select User Type</em>
                            </MenuItem>
                            
                            {listUserTypes?.map((list, index)=>{
                                return(
                                    <MenuItem key={index} value={list} sx={{fontSize: 12}}>
                                        {list}
                                    </MenuItem>
                                )
                            })}
                        </SmallSelect>
                    </FormControl>

                    &nbsp;&nbsp;&nbsp;&nbsp;

                    <ReactSelect
                        isMulti
                        isRtl={false}
                        options={formattedProductList}
                        value={selectedProducts} 
                        onChange={selectedOption => handleSelectProductFilter(selectedOption)}
                        styles={filterStyles}
                        isClearable={false}
                        placeholder={(selectedProducts?.length > 0) ? null : "Select Product Name"}
                        noOptionsMessage={() => "No matching product found."} 
                        menuPortalTarget={document.body} 
                        menuPosition="fixed"
                    />

                    &nbsp;&nbsp;&nbsp;&nbsp;

                    <DateRangePickerComponent
                        initialStartDate={startDate}
                        initialEndDate={endDate}
                        ranges={{
                            "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                            "This Month": [moment().startOf('month'), moment().endOf('month')],
                            "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                        }}
                        onDateRangeChange={handleDateRangeChange}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                        onClick={handleExport}
                        variant="contained"
                        startIcon= {isLoadingAlertNotification ? <CircularProgress sx={{color:'white'}} size={11} /> : <DownloadIcon />}
                        sx={{ fontSize: 12, background: '#3333CFCE', color: '#fff', textTransform: 'none', height: "33px", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                    >
                        {isLoadingAlertNotification ? "Exporting" : "Export"}
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{ width: '100%', overflow: 'hidden', mt: 3,  }}>
                    <TableContainer sx={{ border: "1px solid #3333cf54", borderRadius: 2, width: "100%", maxHeight: 600}}>
                        <Table stickyHeader sx={{ minWidth: 650 }}>
                            <ReportsTableHeader headers={headers} />
                            {loadingVerificationFrequency ? 
                                <TableBody>
                                    <VerificationFrequencySkeleton/>
                                </TableBody>
                            :
                                <TableBody>
                                    {currentItems?.map((label, index) => (
                                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">
                                                {label.productInfo.product_name}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {label.product_code}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {label?.maxVerificationHour + ': 00'}
                                            </TableCell>
                                            
                                            <TableCell component="th" scope="row">
                                                {label.maxVerificationCount}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label.user_type || "N / A"}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            }
                        </Table>

                        {/* ERROR MESSAGE */}
                        {!loadingVerificationFrequency && currentItems?.length === 0 && <Box sx={{textAlign:'center', m: 2}}> <Typography sx={{color:'gray', fontSize: 12}}>No data available.</Typography></Box>}
                                            
                    </TableContainer>

                    {/* PAGINATION */}
                    {!loadingVerificationFrequency ?
                        <Box display="flex" justifyContent="center" mt={2} mb={2}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        color: "#fff",
                                        backgroundColor: "#5959D8"
                                    }
                                }} 
                            />
                        </Box>
                    : null}
                </Paper>
            </Grid>
            {/* DIALOG */}
            <ExportAlertNotificationDialog open={open} reportID={reportID} handleClose={handleClose}/>
        </Box>
    )

}

export default VerificationFrequencyFilterComponent